/* ==========================================================================
   BRACELY — shrink-on-scroll header
   --------------------------------------------------------------------------
   Adds/removes a single class on <html>; all sizing and easing lives in
   assets/bracely-header.css.

   Uses its own scroll state rather than Horizon's data-scroll-direction,
   because that attribute also flips when scrolling back up mid-page — we want
   the large logo only at the very top of the document.

   The on/off thresholds differ (hysteresis) so the header can't flicker when
   the visitor hovers around the trigger point.
   ========================================================================== */

(function () {
  'use strict';

  var COMPACT_ON = 72; // px scrolled before the header tightens
  var COMPACT_OFF = 28; // px it must return to before expanding again

  var root = document.documentElement;
  var isCompact = false;
  var ticking = false;

  function apply() {
    var y = window.scrollY || root.scrollTop || 0;

    if (!isCompact && y > COMPACT_ON) {
      isCompact = true;
      root.classList.add('bracely-header-compact');
    } else if (isCompact && y < COMPACT_OFF) {
      isCompact = false;
      root.classList.remove('bracely-header-compact');
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      apply();
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  // Set the correct state immediately, including on a restored/anchored scroll
  // position where the page does not start at the top.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  window.addEventListener('load', apply);
})();
